module.exports = __webpack_public_path__ + "static/media/University.703f9187.svg";